var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00059 6.05156L1.32559 9.72656C1.18809 9.86406 1.01309 9.93281 0.800586 9.93281C0.588086 9.93281 0.413086 9.86406 0.275586 9.72656C0.138086 9.58906 0.0693359 9.41406 0.0693359 9.20156C0.0693359 8.98906 0.138086 8.81406 0.275586 8.67656L3.95059 5.00156L0.275586 1.32656C0.138086 1.18906 0.0693359 1.01406 0.0693359 0.801562C0.0693359 0.589062 0.138086 0.414062 0.275586 0.276562C0.413086 0.139062 0.588086 0.0703125 0.800586 0.0703125C1.01309 0.0703125 1.18809 0.139062 1.32559 0.276562L5.00059 3.95156L8.67559 0.276562C8.81309 0.139062 8.98809 0.0703125 9.20059 0.0703125C9.41309 0.0703125 9.58809 0.139062 9.72558 0.276562C9.86308 0.414062 9.93184 0.589062 9.93184 0.801562C9.93184 1.01406 9.86308 1.18906 9.72558 1.32656L6.05059 5.00156L9.72558 8.67656C9.86308 8.81406 9.93184 8.98906 9.93184 9.20156C9.93184 9.41406 9.86308 9.58906 9.72558 9.72656C9.58809 9.86406 9.41309 9.93281 9.20059 9.93281C8.98809 9.93281 8.81309 9.86406 8.67559 9.72656L5.00059 6.05156Z",
    fill: "#6F0D0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSvg);
export default __webpack_public_path__ + "static/media/CloseSvg.c668bdd91b4e134b3c7810b7eaa4135a.svg";
export { ForwardRef as ReactComponent };